import React from 'react'
import Viewer360 from '../viewer360.Component';
import BikeBarMobile from './UI/bikebar.Component';
import HeaderMobile from './UI/header.Component';
import SidebarMobile from './UI/sidebar.Component';
import SocialMediaMobile from './UI/socialMedia.Component';
import BikeView from './viewer3D/bikeView.component';
import GalleryBarMobile from './UI/galleryBar.component'
import FullGalleryMobile from './UI/fullGallery.component'
import FichaMobile from './UI/fichaTecnica.component';
import OpenBulletMobile from './UI/openBullet.component'
import Redirection from './UI/redirection.Component';

interface Props{
    handleToogleMenu: any
    isMenuOpened: boolean
    isFullScreen:boolean
    isMuted: boolean
    handleFullScreen: any
    handleAudio: any
    handleFamilyBtnClick: any
    handleBackBtn: any
    isFamilias: boolean
    isFamiliaSelected: boolean
    selectedBikeFamily: any,
    handleBike: any,
    selectedBike: any
    selectedIndividualBike: boolean,
    currentPanorama: string,
    currentScene: any,
    handlePanoUpdate: any,
    handleOpenMultimedia: any,
    handleOpenSpin: any,
    handleOpenFichaTecnica: any,
    handleOpenFormulario: any,
    isMultimediaOpened: boolean,
    isSpinOpened: boolean,
    isFichaOpened: boolean,
    isFormularioOpened: boolean,
    handleOpenImage: any,
    isGalleryOpened: boolean,
    currentImage: number,
    currentColor: string,
    currentSet: any,
    currentColorsArray: any,
    currentColorIndex: number,
    handleChangeColors: any,
    handleCloseSpin: any,
    isFullFichaOpened: boolean,
    handleFullFicha: any,
    isMobile: boolean,
    handleMotoMes: any,
    handleOpenBullet: any,
    currentBulletImage: string,
    currentBulletText: string,
    openBullet: boolean,
    openRedirectionBar: boolean
    handleOpenRedirection: any
}

interface State{}

class Main360Mobile extends React.Component<Props, State>{
    constructor(props: Props){
        super(props);
    }

    render(){
        return(
            <div className='main-screen-360-component-mobile'>
                {<Viewer360
                    currentPanorama = {this.props.currentPanorama}
                    currentScene = {this.props.currentScene}
                    handlePanoUpdate = {this.props.handlePanoUpdate}
                    handleOpenBullet = {this.props.handleOpenBullet}
                />}
                {/*<SocialMediaMobile/>*/}
                <BikeBarMobile 
                    selectedBike={this.props.selectedBike}
                    selectedIndividualBike={this.props.selectedIndividualBike}
                    handleOpenMultimedia = {this.props.handleOpenMultimedia}
                    handleOpenSpin = {this.props.handleOpenSpin}
                    handleOpenFichaTecnica = {this.props.handleOpenFichaTecnica}
                    handleOpenFormulario = {this.props.handleOpenFormulario}
                    isMultimediaOpened = {this.props.isMultimediaOpened}
                    isSpinOpened = {this.props.isSpinOpened}
                    isFichaOpened = {this.props.isFichaOpened}
                    isFormularioOpened = {this.props.isFormularioOpened}
                />
                <BikeView
                    isSpinOpened = {this.props.isSpinOpened}
                    selectedBike = {this.props.selectedBike}
                    currentColor = {this.props.currentColor}
                    currentSet = {this.props.currentSet}
                    currentColorsArray = {this.props.currentColorsArray}
                    currentColorIndex = {this.props.currentColorIndex}
                    handleChangeColors = {this.props.handleChangeColors}
                    handleCloseSpin = {this.props.handleCloseSpin} 
                />
                <GalleryBarMobile
                    isMultimediaOpened = {this.props.isMultimediaOpened}
                    selectedBike={this.props.selectedBike}
                    handleOpenMultimedia = {this.props.handleOpenMultimedia}
                    handleOpenImage = {this.props.handleOpenImage}
                />
                <FullGalleryMobile
                    isGalleryOpened = {this.props.isGalleryOpened}
                    currentImage = {this.props.currentImage}
                    selectedBike = {this.props.selectedBike}
                    handleOpenImage = {this.props.handleOpenImage}
                />
                <FichaMobile
                    isFichaOpened = {this.props.isFichaOpened}
                    selectedBike = {this.props.selectedBike}
                    handleOpenFichaTecnica = {this.props.handleOpenFichaTecnica}
                    handleOpenOnline = {this.props.handleFullFicha}
                />
                <OpenBulletMobile
                    openBullet = {this.props.openBullet}
                    currentBulletImage = {this.props.currentBulletImage}
                    currentBulletText = {this.props.currentBulletText}
                    handleOpenBullet = {this.props.handleOpenBullet}
                />
                <SidebarMobile
                    isMenuOpened = {this.props.isMenuOpened}
                    handleFamilyBtnClick={this.props.handleFamilyBtnClick}
                    handleBackBtn={this.props.handleBackBtn}
                    isFamilias={this.props.isFamilias}
                    isFamiliaSelected={this.props.isFamiliaSelected}
                    selectedBikeFamily={this.props.selectedBikeFamily}
                    handleBike = {this.props.handleBike}
                    handleMotoMes = {this.props.handleMotoMes}
                />
                <Redirection
                    handleOpenRedirection = {this.props.handleOpenRedirection}
                    openRedirectionBar = {this.props.openRedirectionBar}
                    selectedBike = {this.props.selectedBike}
                />
                <HeaderMobile
                    handleToogleMenu = {this.props.handleToogleMenu}
                    isMenuOpened = {this.props.isMenuOpened}
                    isFullScreen = {this.props.isFullScreen}
                    isMuted = {this.props.isMuted}
                    handleFullScreen = {this.props.handleFullScreen}
                    handleAudio = {this.props.handleAudio}
                />
            </div>
        )
    }
}

export default Main360Mobile